export { default as H1 } from './H1';
export { default as H2 } from './H2';
export { default as SectionTitle } from './SectionTitle';
export { default as Body } from './Body';
export { default as Fine } from './Fine';
export { default as Label } from './Label';
